import Work1 from "../../assets/work1.png"
import Work2 from "../../assets/work2.png"
import Work3 from "../../assets/work3.png"
import Work4 from "../../assets/work4.png"
import Work5 from "../../assets/work5.png"



export const ProjectsData = [
    {
        id: 1,
        image: Work1,
        title: 'Predicting Diabetes using ANNs',
        link: 'https://github.com/salarMokhtariL/Diabetes-Prediction',
        category: 'Ai',
    },
    {
        id: 2,
        image: Work2,
        title: 'House Price Prediction',
        link:'https://github.com/salarMokhtariL/House-Price-Prediction-Regression-Modeling',
        category: 'Ai',
    },
    {
        id: 3,
        image: Work3,
        title: 'Parkinson Disease Prediction',
        link:'https://github.com/salarMokhtariL/PD-Progress-Prediction',
        category: 'Ai',
    },
    {
        id: 4,
        image: Work4,
        title: 'Fake News Detection',
        link:'https://github.com/salarMokhtariL/Fake-News-Detection-using-DistilBERT-Pretrained-Model-and-Transfer-Learning',
        category: 'Ai',
    },
    {
        id: 5,
        image: Work5,
        title: 'Groceries Recommender System',
        link:'https://github.com/salarMokhtariL/Fake-News-Detection-using-DistilBERT-Pretrained-Model-and-Transfer-Learning',
        category: 'Web',
    },

];

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'Ai',
    },
    {
        name: 'Web',
    },
]